module.exports = __webpack_public_path__ + "static/media/b99-fb-comments.d31bbe43.png";